import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-tools-hummer-icon',
  templateUrl: './tools-hummer.component.html'
})
export class ToolsHummerComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
